import { render, staticRenderFns } from "./TmplExport.vue?vue&type=template&id=97b3665c"
import script from "./TmplExport.vue?vue&type=script&lang=js"
export * from "./TmplExport.vue?vue&type=script&lang=js"
import style0 from "./TmplExport.vue?vue&type=style&index=0&id=97b3665c&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports